export const ANIMATION_COMPLETE_CLASS = 'animation-complete';
